const checkBetweenDateRange = (startDate: Date, endDate: Date): boolean => {
  // locale specific
  const currentDate = Date.now();
  return currentDate >= startDate.getTime() && currentDate <= endDate.getTime();
};

export default checkBetweenDateRange;
